var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCartUpdated = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6101 120C39.2716 120 33.334 126 33.334 133.333C33.334 140.667 39.2716 146.667 46.6101 146.667C53.9487 146.667 59.953 140.667 59.953 133.333C59.953 126 53.9487 120 46.6101 120ZM113.324 120C105.986 120 100.048 126 100.048 133.333C100.048 140.667 105.986 146.667 113.324 146.667C120.663 146.667 126.667 140.667 126.667 133.333C126.667 126 120.663 120 113.324 120Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3343 133.333C53.3343 137.015 50.3495 140 46.6676 140C42.9857 140 40.001 137.015 40.001 133.333C40.001 129.652 42.9857 126.667 46.6676 126.667C50.3495 126.667 53.3343 129.652 53.3343 133.333Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.001 133.333C120.001 137.015 117.016 140 113.334 140C109.652 140 106.668 137.015 106.668 133.333C106.668 129.652 109.652 126.667 113.334 126.667C117.016 126.667 120.001 129.652 120.001 133.333Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8003 98.3333L48.0003 97.5332L54.0003 86.6666H103.667C108.667 86.6666 113.067 83.9333 115.334 79.7999L141.067 33.0666L129.467 26.6666H129.4L122.067 39.9999L103.667 73.3333H56.867L56.0003 71.5332L41.067 39.9999L34.7337 26.6666L28.467 13.3333H6.66699V26.6666H20.0003L44.0003 77.2666L35.0003 93.5999C33.9337 95.4666 33.3337 97.6666 33.3337 99.9999C33.3337 107.333 39.3337 113.333 46.667 113.333H126.667V99.9999H49.467C48.6003 99.9999 47.8003 99.2666 47.8003 98.3333Z",
    fill: "#FFD600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2541 33.8709L65.8749 22.4918L62 26.3394L77.2541 41.5935L110 8.84764L106.152 5L77.2541 33.8709Z",
    fill: "#17CF63"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartUpdated, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CartUpdated.8dbcc0d7.svg";
export { ForwardRef as ReactComponent };